export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";